export enum PopupFilterType {
  EntityName = 'ActivityName',
  Category = 'Category',
  GroupingOptions = 'GroupingOptions',
  SortingOptions = 'SortingOptions',
  Saved = 'Saved',
  Calendar = 'Calendar',
}
